import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import ProcessAutomation from './ProcessAutomation';

export default function Blog() {
  return (
    <>
        <Navbar />
        <ProcessAutomation />
        <Footer />
        <Copyright />
    </>
  )
}